import * as AxiosHttpClient from '../AxiosHttpClient';

export class HttpClientTestHook{
  constructor(
  ) { }
  public notifyOnZeroActiveRequests(callback: () => void)
  {
    AxiosHttpClient.default.notifyWhenNoActiveRequest(callback);
  }
}

(window as any).HttpClientTestHook = new HttpClientTestHook();

